import { UserStorageKey } from "./userStorageKey";
// import FastMutex from "fast-mutex";

/***
 * Use this function to write global values to user storage, when session values
 * are of no importance and values can be safely overrun (Like reloading the app)
 * @param key from UserStorageKey - to keep things orgenized
 * @param value - string value to ve written to storage
 */
export const writeToGlobalStorage = (
  key: UserStorageKey | string,
  value: string,
) => {
  return writeAtomicGlobalStorage(key, () => value);
};

export const readFromGlobalStorage = <T>(key: UserStorageKey | string) => {
  const raw = localStorage.getItem(key as string);
  try {
    return JSON.parse(raw) as T;
  } catch (e) {
    // If the value is in string form the parse will fail
    return raw;
  }
};
/**
 * Returns all keys cross session
 * @param key
 */
export const getAllStorageKeys = (key: UserStorageKey | string) => {
  const regEx = new RegExp(`-*${key}`);
  let keys = [];
  for (key in localStorage) {
    if (regEx.test(key)) keys.push(key);
  }
  return keys;
};
/***
 * Rerturnes all user storage keys assosicated with a certain session
 * @param sessionId
 */
export const getAllSessionKeys = (sessionId: string) => {
  const regEx = new RegExp(`${sessionId}-*`);
  let keys = [];
  for (let key in localStorage) {
    if (regEx.test(key)) keys.push(key);
  }
  return keys;
};
/**
 * Use this function when writing values that might affect different tabs
 * such as state, stored lists etc
 * @param key the storage key to which the data will be stored
 * @param setter a function receiving the older value and returning the one
 * value to right
 */
export const writeAtomicGlobalStorage = <T>(
  key: UserStorageKey | string,
  setter: (preValue: T) => T,
): T => {
  //const mutex = new FastMutex();
  //mutex
  //  .lock(key)
  //  .then(() => {
  //Read previous value
  const atomicValue = setter(readFromGlobalStorage(key) as any) as T | null;
  if (typeof atomicValue === "string") {
    localStorage.setItem(key, atomicValue);
  } else {
    localStorage.setItem(key, JSON.stringify(atomicValue));
  }
  return atomicValue;
  // release the lock when you're done.
  //return mutex.release(key);
  //})
  // .catch((err) => {
  //   // console.log(
  //   //   `Failed write key: ${key} to atomic global storage, error:${err.message}`,
  //   // );
  // });
};

export const clearGlobalStorage = (key: UserStorageKey | string) =>
  localStorage.removeItem(key);
